__turbopack_context__.v({
  "introContent": "Vp02LG_introContent",
  "paragraph": "Vp02LG_paragraph",
});
